"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.parseInterpolationParams = parseInterpolationParams;

var _Markdown = _interopRequireWildcard(require("./Markdown"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function parseInterpolationParams(text, interpolationParams) {
  Object.keys(interpolationParams).forEach(param => {
    const variableTemplate = `{{${param}}}`;
    text = text.replace(new RegExp(variableTemplate, "g"), interpolationParams[param]);
  });
  return text;
}

function get(text, interpolationParams = null) {
  if ((0, _Markdown.hasMarkdownCharacters)(text)) {
    text = (0, _Markdown.default)(text);
  }

  if (interpolationParams !== null) {
    text = parseInterpolationParams(text, interpolationParams);
  }

  return text;
}